module.exports = __webpack_public_path__ + "media/img/seed/8-ccd74d69baf182e972259a8a75ce70d3.jpeg";